module.exports = __webpack_public_path__ + "static/intersocca-7645211371579bdc831c36edebef24c8.jpg";